import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IPayload {
    customerId:string;
    linkedAccountId: string;
    amount: string;
}

export const useAddMoneyMutation = ({ customerId, linkedAccountId, amount }: IPayload, onSuccess: (transactionId: string)=> void, onError: (data: any)=> void) => {
  let parsedAmount = 0;
  try {
    parsedAmount = JSON.parse(amount
      .replace('$', '')
      .replaceAll(',', '')
      .replaceAll(' ', ''));
  } catch (e) {
    console.error(e);
    parsedAmount = 0;
  }
  return useMutation(
    'addMoney',
    async () => {
      const { data } = await httpService.post(`${BASE_URL}/api/v3/user/${customerId}/pullFrom/${linkedAccountId}`, {
        amount: parsedAmount,
      });
      return data;
    },
    {
      onSuccess: (data) => {
        onSuccess(data.transactionId);
      },
      onError: (e: any) => {
        console.error(e);
        onError(e.response.data.errors[0]);
      },
    },
  );
};
